import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import type { Patient } from "../../app-patient/_objects-patient";
import { RequestContext } from "../../request-context";
import { requestPost, requireResult } from "../../utils/network";
import ActionButton from "../../widget/action-button";
import FormValidating from "../../widget/form-validating";
import { Modes } from "../../widget/io-abstract";
import IONumber from "../../widget/io-number";
import { MenuItem } from "./menu-item";

export function MenuPatientGenerateReference() {
  const requestCtx = useContext(RequestContext)!;
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <FormValidating
      action={(formData: FormData) =>
        requestCtx
          .fetchJSONAndMessage<Patient>(
            `Creating reference ${currentYear}`,
            requestPost("/api/patient", formData)
          )
          .then(requireResult)
          .then((patient) => {
            navigate(`/patient/${patient.id}/patient/${patient.id}/edit`);
          })
      }
      className="menu-item"
    >
      <MenuItem
        title="Generate a reference"
        requires="write"
        // versalIcon={icons.models.patient}
        buttons={[
          <ActionButton
            action="Generate"
            key="generate"
            style={"Add"}
            type="submit"
          />
        ]}
      >
        <IONumber
          mode={Modes.input}
          name="entry_year"
          value={currentYear}
          htmlProps={{ min: 2000, max: currentYear }}
        />
      </MenuItem>
    </FormValidating>
  );
}
